<form [formGroup]="formGroup" appPropagateSubmit [parentFormGroupDirective]="parentFormGroupDirective">
  <div class="mt-3">
    <h6>Antrag</h6>
    <div class="row">
      <div class="col col-xs-12 col-sm-12">
        <div class="input_radio" *ngIf="!eingereicht; else antragInfo">
          <app-label [control]="antragUebernehmen" for="antragUebernehmen">Der Antrag aus der Berechnung wird direkt übernommen. Alternativ ist es auch möglich den unterschriebenen Antrag mit der gleichen ID hochzuladen. Nachträglich veränderte Inhalte werden nicht berücksichtigt.</app-label>
          <mat-radio-group id="antragUebernehmen" formControlName="antragUebernehmen">
            <mat-radio-button value="1">Antrag mit der ID {{offertBaseId}} übernehmen</mat-radio-button>
            <mat-radio-button value="2">Unterschriebene Version des Antrags mit der ID {{offertBaseId}} hochladen</mat-radio-button>
          </mat-radio-group>
          <mat-error *ngIf="antragUebernehmen.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
        </div>
        <ng-template #antragInfo>
          <p>Der Antrag mit der ID {{offertBaseId}} wurde bereits{{ einreichdatum ? ' am' (antragEinreichdatum | date) : '' }} übersendet.</p>
        </ng-template>
      </div>
      <div class="col col-xs-12 col-sm-12">
        <ng-container *ngIf="showUploadAntrag">
          <app-file-upload [parentFormGroupDirective]="parentFormGroupDirective" [dokumentArt]="dokumentArten.Antrag" [required]="true" [multiple]="false" [selectedFilesTotal]="selectedFiles" [acceptedFileTypes]="'application/pdf'"></app-file-upload>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="mt-3">
    <h6>Antragsbeilagen</h6>
    <div class="row">
      <div class="col col-xs-12 col-sm-12">
        <p>Sie haben die Möglichkeit Dokumente dem Antrag beizulegen oder nachträglich per Email an Ihren Betreuer an {{ vermittlerService.vermittlerResult.StandortEmail  }} senden.</p>
      </div>
    </div>
  </div>
</form>
